__turbopack_context__.v({
  "attachment": "SocialPost-module__oUtcua__attachment",
  "attachmentImage": "SocialPost-module__oUtcua__attachmentImage",
  "attachmentName": "SocialPost-module__oUtcua__attachmentName",
  "attachmentRow": "SocialPost-module__oUtcua__attachmentRow",
  "attachmentSize": "SocialPost-module__oUtcua__attachmentSize",
  "author": "SocialPost-module__oUtcua__author",
  "avatar": "SocialPost-module__oUtcua__avatar",
  "body": "SocialPost-module__oUtcua__body",
  "bodyField": "SocialPost-module__oUtcua__bodyField",
  "card": "SocialPost-module__oUtcua__card",
  "commentField": "SocialPost-module__oUtcua__commentField",
  "content": "SocialPost-module__oUtcua__content",
  "cover": "SocialPost-module__oUtcua__cover",
  "coverImage": "SocialPost-module__oUtcua__coverImage",
  "field": "SocialPost-module__oUtcua__field",
  "footer": "SocialPost-module__oUtcua__footer",
  "header": "SocialPost-module__oUtcua__header",
  "headerActions": "SocialPost-module__oUtcua__headerActions",
  "identity": "SocialPost-module__oUtcua__identity",
  "imageAction": "SocialPost-module__oUtcua__imageAction",
  "imageFrame": "SocialPost-module__oUtcua__imageFrame",
  "introduction": "SocialPost-module__oUtcua__introduction",
  "lockAction": "SocialPost-module__oUtcua__lockAction",
  "lockIcon": "SocialPost-module__oUtcua__lockIcon",
  "lockNotice": "SocialPost-module__oUtcua__lockNotice",
  "locked": "SocialPost-module__oUtcua__locked",
  "media": "SocialPost-module__oUtcua__media",
  "mediaList": "SocialPost-module__oUtcua__mediaList",
  "metadata": "SocialPost-module__oUtcua__metadata",
  "remove": "SocialPost-module__oUtcua__remove",
  "teaser": "SocialPost-module__oUtcua__teaser",
  "teaserField": "SocialPost-module__oUtcua__teaserField",
  "title": "SocialPost-module__oUtcua__title",
  "titleField": "SocialPost-module__oUtcua__titleField",
  "video": "SocialPost-module__oUtcua__video",
});
